const View = () => import("~/components/Views/Prova/ConsultarProva/View");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Consultas", link: "" }
];

export const visualizarProva = [
  {
    path: "view/:aplicacaoProvaId/:alunoId",
    component: View,
    name: "Visualizar Prova",
    meta: {
      middleware: [auth, grupoVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/visualizarProva.js